webpackJsonp([159968804749312],{

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Building = __webpack_require__(101);
	
	var _Building2 = _interopRequireDefault(_Building);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _Video = __webpack_require__(15);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Building2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Custom Build'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'New projects include built-in support for development and production builds of your application, but you can also create custom environments, in case you also need special builds for environments like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'test'
	      ),
	      ', ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'staging'
	      ),
	      ', etc.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To illustrate, we\'ll walk through the steps required to add a new build for a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'staging'
	      ),
	      ' environment.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Create Custom Config'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The first step is to create a custom config file, and add it to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/config/env'
	      ),
	      '. In this example we will create a new file named ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/config/env/staging.js'
	      ),
	      ' that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      /**\n       * Staging environment settings\n       *\n       * This file is where you define overrides for any of the config settings that\n       * should only be applied in the staging environment.\n       *\n       * The staging environment is defined as \'process.env.LORE_ENV=staging\' and\n       * is automatically set when webpack is invoked using the --env.lore=staging argument.\n       **/\n\n      export default {\n\n        /**\n         * To override a config setting, specify the name of the config file you\n         * want to override, followed by the settings you want to change.\n         */\n\n        // actions: {\n        //   normalize: true\n        // },\n\n        // connections: {\n        //   default: {\n        //     apiRoot: \'https://api.example.dev\'\n        //   }\n        // }\n\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This file allows us to customize the application settings for this environment, such as setting the API location, specific feature flags, whatever we need.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Create Custom Script'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we need to add a script to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'package.json'
	      ),
	      ' so that we can build the project for this environment. For that, we\'re going to add the script below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      "scripts": {\n        "build:staging": "npm run clean && webpack --env.webpack=production --env.lore=staging -p",\n      },\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This script will tell webpack to build the files in production mode, which sets the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'NODE_ENV'
	      ),
	      ' to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'production'
	      ),
	      ', but then tells lore to use the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'staging'
	      ),
	      ' config. The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '-p'
	      ),
	      ' at the end tells Webpack to minify and uglify the assets.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Done!'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'That\'s it! Those steps are all you need to set up your own custom build environments, and you can create as many as you want.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-building-environments-custom-js-b2d717301e9201ee4d2c.js